/**
 * Selection of `QualityReport` (tab Qualitätsprotokoll), shared by the page fragment and the block
 * project-quality-report-data, so both read the same fields.
 */
export const QUALITY_REPORT_SELECTION = `
  completed {
    type
    value
  }
  isRoofAccessibleFromInsideState
  isRoofAccessibleFromInsideNote
  properSleeveUsedAtRoofPenetrationState
  underlaySealedWellAtCableEntryState
  underlayDamagedOrWaterStainsState
  labelingOfStringLinesState
  pvStringCableCorrectCrossSectionState
  peCableCorrectlySizedState
  cablesProperlySecuredState
  crimpingProfessionallyDoneState
  correctSelectionOfPvConnectorsOnStringCableState
  allPlugConnectionsProfessionallyMadeState
  cablesNeatlyLaidInsideBuildingState
  spdBoxPresentIfCableInBuildingLongerThan10mInstalledBeforeInverterState
  surgeProtectionBoxProperlyWiredInstallSpdAtRoofEntryState
  properSleeveUsedAtRoofPenetrationNote
  underlaySealedWellAtCableEntryNote
  underlayDamagedOrWaterStainsNote
  labelingOfStringLinesNote
  pvStringCableCorrectCrossSectionNote
  peCableCorrectlySizedNote
  cablesProperlySecuredNote
  crimpingProfessionallyDoneNote
  correctSelectionOfPvConnectorsOnStringCableNote
  allPlugConnectionsProfessionallyMadeNote
  cablesNeatlyLaidInsideBuildingNote
  spdBoxPresentIfCableInBuildingLongerThan10mInstalledBeforeInverterNote
  surgeProtectionBoxProperlyWiredInstallSpdAtRoofEntryNote
  documentationProjectReportAvailableState
  specialCustomerRequestsDocumentedState
  tileTypeAndWidthDocumentedState
  replacementTileInstalledState
  lightningProtectionPresentState
  documentationProjectReportAvailableNote
  specialCustomerRequestsDocumentedNote
  tileTypeAndWidthDocumentedNote
  replacementTileInstalledNote
  lightningProtectionPresentNote
  substructureTensionFreeCheckedState
  substructureInstalledAsPerReportState
  eachRailSecuredWithMinTwoHooksState
  distanceBetweenHooksMoreThan140cmState
  correctRoofHooksUsedState
  distanceRoofHookToTile35mmState
  minScrewDistanceToRafterEdge24mmState
  roofHookProperlyFixedToRafterState
  overhangObservedState
  moduleFieldProperlyGroundedState
  substructureTensionFreeCheckedNote
  substructureInstalledAsPerReportNote
  eachRailSecuredWithMinTwoHooksNote
  distanceBetweenHooksMoreThan140cmNote
  correctRoofHooksUsedNote
  distanceRoofHookToTile35mmNote
  minScrewDistanceToRafterEdge24mmNote
  roofHookProperlyFixedToRafterNote
  overhangObservedNote
  moduleFieldProperlyGroundedNote
  approvedAuxiliaryRafterUsedState
  approvedAuxiliaryRafterUsedNote
  rafterWidthMeasuredAndComparedToDocsState
  rafterWidthMeasuredAndComparedToDocsNote
  noOpenOrDamagedTilesState
  noOpenOrDamagedTilesNote
  noShiftedOrIncorrectlyLaidTilesState
  noShiftedOrIncorrectlyLaidTilesNote
  tilesProperlyCleanedState
  tilesProperlyCleanedNote
  correctPanHeadScrewsUsedState
  correctPanHeadScrewsUsedNote
  minRailOverhangAfterEndClamp20mmState
  minRailOverhangAfterEndClamp20mmNote
  distancesToRidgeEavesNotLessThan20cmState
  distancesToRidgeEavesNotLessThan20cmNote
  moduleClampAreasObservedState
  moduleClampAreasObservedNote
  modulesNoDamagesDirtShadingState
  modulesNoDamagesDirtShadingNote
  moduleClampsProperlyTightenedState
  moduleClampsProperlyTightenedNote
  thermalSeparationAfter12mModuleFieldState
  thermalSeparationAfter12mModuleFieldNote
  breakthroughProperlySealedState
  breakthroughProperlySealedNote
  distanceLightningProtectionToConductivePartsLessThan05mState
  distanceLightningProtectionToConductivePartsLessThan05mNote
  gutterUndamagedState
  gutterUndamagedNote
  notBuiltOverRoofOverhangState
  notBuiltOverRoofOverhangNote
  cableProperlyLaidInChimneyState
  cableProperlyLaidInChimneyNote
  distanceToDisturbingSurfaces10cmObservedState
  distanceToDisturbingSurfaces10cmObservedNote
  cableEntryWithReplacementPlateAndFlexedTileState
  cableEntryWithReplacementPlateAndFlexedTileNote
  cablesDoNotRestOnTilesState
  cablesDoNotRestOnTilesNote
  cablesLaidProtectedUnderTilesState
  cablesLaidProtectedUnderTilesNote
  cableEntryOnRoofProperlyDoneState
  cableEntryOnRoofProperlyDoneNote
  cableLaidThroughChimneyState
  cableLaidThroughChimneyNote
  cableLaidInProtectiveSleeveAgainstUvRadiationState
  cableLaidInProtectiveSleeveAgainstUvRadiationNote
  peCableProperlySecuredState
  peCableProperlySecuredNote
  documentationProjectReportPresentState
  documentationProjectReportPresentNote
  customerSpecialRequestsConsideredState
  customerSpecialRequestsConsideredNote
  flatRooflightningProtectionPresentState
  flatRooflightningProtectionPresentNote
  properGroundingFlatRoofSystemState
  properGroundingFlatRoofSystemNote
  ballastingAccordingToProjectReportState
  ballastingAccordingToProjectReportNote
  minimumModuleBearingAreaMaintainedState
  minimumModuleBearingAreaMaintainedNote
  qFlatProperlyConnectedState
  qFlatProperlyConnectedNote
  distanceToDisturbingSurfacesMaintainedState
  distanceToDisturbingSurfacesMaintainedNote
  flatRoofmoduleClampsProperlyTightenedState
  flatRoofmoduleClampsProperlyTightenedNote
  modulesNoDamageDirtShadingState
  modulesNoDamageDirtShadingNote
  typeOfCableProtectionOutdoorsState
  typeOfCableProtectionOutdoorsNote
  correctSelectionOfPvConnectorsState
  correctSelectionOfPvConnectorsNote
  cablesDoNotRestOnRoofState
  cablesDoNotRestOnRoofNote
  cableEntryDoneProperlyState
  cableEntryDoneProperlyNote
  cablesProtectedFromUvState
  cablesProtectedFromUvNote
  pvStringCableProperlySizedState
  pvStringCableProperlySizedNote
  stringCableLabelingState
  stringCableLabelingNote
  peCableProperlySizedState
  peCableProperlySizedNote
  flatRoofcablesProperlySecuredState
  flatRoofcablesProperlySecuredNote
  crimpingProperlyDoneState
  crimpingProperlyDoneNote
  pvSystemLabeledInOrAtDistributionBoardState
  pvSystemLabeledInOrAtDistributionBoardNote
  testReportAvailableWithAllMeasurementsState
  testReportAvailableWithAllMeasurementsNote
  rcdTypeB300maAvailableInMeterAreaState
  rcdTypeB300maAvailableInMeterAreaNote
  stringPlanFiledInMeterCabinetState
  stringPlanFiledInMeterCabinetNote
  safetyDistancesMaintainedState
  safetyDistancesMaintainedNote
  correctLocationForSystemState
  correctLocationForSystemNote
  correctLocationForWallboxState
  correctLocationForWallboxNote
  customerRequestsDocumentedState
  customerRequestsDocumentedNote
  slsInstalledState
  slsInstalledNote
  componentsDamagedState
  componentsDamagedNote
  crimpingDoneProperlyState
  crimpingDoneProperlyNote
  ussWiredProperlyInCabinetState
  ussWiredProperlyInCabinetNote
  ussBoxWiredProperlyState
  ussBoxWiredProperlyNote
  bendingRadiiMaintainedState
  bendingRadiiMaintainedNote
  correctWiringOfMateboxState
  correctWiringOfMateboxNote
  correctWiringOfBatteryState
  correctWiringOfBatteryNote
  allComponentsProperlyGroundedState
  allComponentsProperlyGroundedNote
  correctColorCodingAndLabelingState
  correctColorCodingAndLabelingNote
  correctWiringOfPvConnectorsState
  correctWiringOfPvConnectorsNote
  cableDuctProperlySizedAndCutState
  cableDuctProperlySizedAndCutNote
  nhHakSelectiveToSlsState
  nhHakSelectiveToSlsNote
  checkNetworkTypeState
  checkNetworkTypeNote
  earthRodConnectedToHpasState
  earthRodConnectedToHpasNote
  connectionBetweenHpasAndPasProperlyMadeState
  connectionBetweenHpasAndPasProperlyMadeNote
  insulationProperlyStrippedState
  insulationProperlyStrippedNote
  polarityCheckState
  polarityCheckNote
  stringOpenCircuitVoltageState
  stringOpenCircuitVoltageNote
  shortCircuitCurrentState
  shortCircuitCurrentNote
  insulationResistanceState
  insulationResistanceNote
  isConnectorSealingIntactState
  isConnectorSealingIntactNote
  isSurgeProtectionBoxPresenState
  isSurgeProtectionBoxPresentNote
  isSurgeProtectionAtHouseEntryState
  isSurgeProtectionAtHouseEntryNote
  isLightningProtectionDistanceToConductivePartsOfPVSystemAtLeast0_5mState
  isLightningProtectionDistanceToConductivePartsOfPVSystemAtLeast0_5mNote
  isModuleFrameUndamagedState
  isModuleFrameUndamagedNote
  isModuleGlassUndamagedState
  isModuleGlassUndamagedNote
  isBacksheetUndamagedState
  isBacksheetUndamagedNote
  isModuleNotShadedState
  isConnectorProperlyPluggedState
  isConnectorProperlyPluggedNote
  isConnectorSealingIntactState
  isConnectorSealingIntactNote
  isConnectorSealingIntact2State
  isConnectorSealingIntact2Note
  isCableRoutedThroughChimneyState
  isCableRoutedThroughChimneyNote
  isChimneySweeperApprovalGivenState
  isChimneySweeperApprovalGivenNote
  isWallPassageProperlySealedState
  isWallPassageProperlySealedNote
  isModuleNotShaded2State
  isModuleNotShadedNote
  areModuleClampsNotTwistedState
  areModuleClampsNotTwistedNote
  isModuleNotShaded2State
  isChimneySweeperApprovalGiven2State
  isChimneySweeperApprovalGiven2Note
`;
